import styled from 'styled-components'
import colors from 'globals/colors'

export const PaginatorWrapper = styled.div`
  height: 22px;
  line-height: 22px;
  display: flex;
  align-self: center;
`

interface PaginatorNavButtonProps {
  active: boolean
}

export const PaginatorNavButton = styled.button<PaginatorNavButtonProps>`
  background: transparent;
  border: none;
  padding: 0 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${(props) => props.active ? 'pointer' : 'default'};
  
  & > svg .color-stroke {
    stroke: ${(props) => props.active ? colors.darkGrey : colors.lightGrey};
  }
`

export const CurrentPage = styled.div`
  font-size: 13px;
  margin: 0 15px;
`
